import { AIModelChoices } from 'api';

import { AI_MODEL_LABEL_MAP } from '../../constants';

export const formatAiModel = (aiModel: AIModelChoices, obfuscateAi = false): string => {
  return obfuscateAi ? 'Safi' : `AI ${AI_MODEL_LABEL_MAP[aiModel]}`;
};
